





































































































import { Vue, Component } from 'vue-property-decorator';
import { Popup, Picker, Toast } from 'vant';
import clounbtn from '../components/CloundbtnInfo.vue';
import { updateuser, checkUser } from '../api';
import { isWeiXin } from '@/common/ts/common';
import qs from 'qs';

@Component({
  components: {
    clounbtn,
  },
})
export default class Rule extends Vue {
  isInto: boolean = true;
  showLihua: boolean = false;
  unionid: string | null = '';
  rulecontent: any = '';
  name: string = '';
  options: any = ['抖音', '微博', '小红书', 'b站'];
  platform: string = '';
  platformId: string = '';
  schname: string = '';
  phone: string = '';
  sharebtn: any = require('../assets/info/sharebtn.png');
  showshare: boolean = false;
  canmodify: string = '';
  mounted() {
    this.canmodify = this.$route.query.canmodify + '';
    this.unionid = window.localStorage.getItem('unionid');
    if (!isWeiXin()) {
      Toast('请在微信中打开，参与活动');
      return false;
    } else if (
      (this.unionid === null || this.unionid === 'null') &&
      isWeiXin()
    ) {
      this.WechatLogin();
      return false;
    }
    checkUser(this.unionid + '').then((res: any) => {
      if (res.code === 200) {
        this.name = res.data.name;
        this.phone = res.data.phone;
        this.platform = res.data.platform;
        this.platformId = res.data.platformId;
        this.schname = res.data.schname;
      } else {
        this.$router.push('ininfo');
      }
    });
    setTimeout(() => {
      this.showLihua = true;
    }, 100);
    this.isInto = true;
    setTimeout(() => {
      this.isInto = false;
    }, 200);
  }
  goback() {
    this.$router.push('index');
  }
  WechatLogin() {
    const { code, source } = qs.parse(location.search, {
      ignoreQueryPrefix: true,
    });
    if (isWeiXin() && !code) {
      const appId = 'wx536e2bb3e4f6664f';
      location.href = `https://activity.cqcb.com/wechat-auth.html?appId=${appId}&backUrl=${encodeURIComponent(
        location.href,
      )}`;
    }
  }
  pleasejoin() {
    this.showshare = true;
  }
  modifyInfo() {
    this.$router.push('modifyinfo');
  }
}
